import { render, staticRenderFns } from "./MiniTag.vue?vue&type=template&id=2643ee78&"
import script from "./MiniTag.vue?vue&type=script&lang=js&"
export * from "./MiniTag.vue?vue&type=script&lang=js&"
import style0 from "./MiniTag.vue?vue&type=style&index=0&id=2643ee78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports